import { localDate } from '@/platform/lib/utils';
import { Badge, Segment, SegmentContent, SegmentHeader } from '@/platform/ui';
import CommunicationSection from './CommunicationSection';

const metaLine = communication =>
    [
        `${communication.type_label} (${communication.sub_type_label})`,
        `Aangemaakt: ${localDate(communication.created_at)}`,
        communication.expires_at &&
            `Verloopt: ${localDate(communication.expires_at)}`,
    ]
        .filter(Boolean)
        .join(' · ');

const CommunicationCard = ({ communication }) => (
    <Segment>
        <SegmentHeader
            header={
                <span className='inline-flex items-center gap-2'>
                    Communicatie
                    <Badge color={communication.state_color}>
                        {communication.state_label}
                    </Badge>
                </span>
            }
            subheader={metaLine(communication)}
        />
        <SegmentContent>
            <CommunicationSection communication={communication} />
        </SegmentContent>
    </Segment>
);

export default CommunicationCard;
